<template>
  <div>
    <loading-spinner :is-loading="isLoading" />
    <div class="main-content-container container-fluid px-4">
      <!-- Page Header -->
      <div class="page-header row no-gutters pt-4 pb-2">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Demande de régie</span>
        </div>
      </div>
      <div class="row flex pb-2">
        <div class="col-12">
          <h5 class="float-left font-weight-bold mb-0">
            <span>Demande de régie</span>
          </h5>
          <div class="col-12 mt-5">
            <button
              class="btn btn-outline wizard-btn return-btn float-left"
              @click="backToList()"
            >
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              {{ $t("global.return") }}
            </button>
            <button
              v-if="edit"
              class="btn btn-danger next-btn float-right mr-3 px-7"
              @click="cancelEditing()"
            >
              Annuler
            </button>
            <button
              v-if="
                this.$store.state.user.informations.permissions[0]
                  .groupReference == '_super_admin' && !request.effectiveAmount
              "
              class="btn btn-warning next-btn float-right mr-3"
              @click="editDemand()"
            >
              {{ edit ? "Confirmer" : "Modifier" }}
            </button>
            <button
              v-if="
                this.$store.state.user.informations.permissions[0]
                  .groupReference == '_compta' &&
                request.effectiveAmount &&
                request.status != 'TREATED'
              "
              class="btn btn-primary wizard-btn next-btn mr-3 float-right"
              @click="markTreated()"
            >
              MARQUER LA RÉGIE ENREGISTRÉE
            </button>
          </div>
        </div>
      </div>
      <div class="mb-4 pb-5">
        <spinner-dot v-if="loading" />
        <template v-else>
          <div class="card mb-4">
            <div class="card-body p-4">
              <div class="row">
                <div class="py-5 px-5 col-lg-6">
                  <template class="my-5">
                    <recapitulatif-contract-request
                      :request="request"
                      :edit="edit"
                      :allStructures="allStructures"
                      :show-last-two="false"
                    />
                  </template>
                </div>
                <div class="py-5 px-5 col-lg-6">
                  <div
                    v-if="
                      request.status == 'ACCEPTED' ||
                      request.status == 'TREATED'
                    "
                    class="d-flex justify-content-end"
                  >
                    <div
                      class="minibus-demand-positive-opnion d-flex align-items-center justify-content-center mr-5 mt-5"
                    >
                      <svg
                        height="50"
                        width="50"
                        color="#FFFFFF"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path
                          fill="#FFFFFF"
                          d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V198.6C310.1 219.5 256 287.4 256 368C256 427.1 285.1 479.3 329.7 511.3C326.6 511.7 323.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256zM576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368zM476.7 324.7L416 385.4L387.3 356.7C381.1 350.4 370.9 350.4 364.7 356.7C358.4 362.9 358.4 373.1 364.7 379.3L404.7 419.3C410.9 425.6 421.1 425.6 427.3 419.3L499.3 347.3C505.6 341.1 505.6 330.9 499.3 324.7C493.1 318.4 482.9 318.4 476.7 324.7H476.7z"
                        />
                      </svg>
                      <span v-if="request.status == 'TREATED'" class="ml-5"
                        >RÉGIE ENREGISTRÉE</span
                      >
                      <span v-else>APPROUVÉ PAR LE DIRECTEUR</span>
                    </div>
                  </div>
                  <div
                    v-if="
                      (request.status == 'ACCEPTED' ||
                        request.status == 'TREATED') &&
                      request.effectiveAmount
                    "
                    class="d-flex justify-content-end"
                  >
                    <div
                      class="minibus-demand-positive-opnion d-flex align-items-center justify-content-center mr-5 mt-5 purple-background"
                    >
                      <span
                        >Régie donnée le
                        {{
                          request.effectiveAmountDate
                            ? new Date(
                                request.effectiveAmountDate
                              ).toLocaleDateString("fr-FR")
                            : "(pas disponible)"
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="my-5 d-block">
                    <h5 class="mt-3">Project / Actions :</h5>
                    <label>{{ request.description }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer light-bg">
              <div>
                <div
                  class="row flex align-items-center"
                  v-if="
                    (!answered && listOfSupervisor.includes(user.reference)) ||
                    edit
                  "
                >
                  <div class="col-lg-4">
                    <p class="m-0">
                      {{ $t("global.ask.approval.disapproval") }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        class="custom-control-input"
                        @click="answer = true"
                        type="radio"
                        v-model="answer"
                        id="approve"
                        :value="true"
                      />
                      <label class="custom-control-label" for="approve">
                        {{ $t("global.approve") }}
                      </label>
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        class="custom-control-input"
                        @click="answer = false"
                        type="radio"
                        v-model="answer"
                        id="disapprove"
                        :value="false"
                      />
                      <label class="custom-control-label" for="disapprove">
                        {{ $t("global.disapprove") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <button
                      v-if="
                        !answered && listOfSupervisor.includes(user.reference)
                      "
                      class="btn btn-primary wizard-btn next-btn float-right"
                      @click="confirmRequest()"
                    >
                      {{
                        answer &&
                        user.permissions[0].groupReference == "_super_admin"
                          ? "PLANIFER UN RENDEZ-VOUS"
                          : $t("global.submit")
                      }}
                    </button>
                  </div>
                  <div
                    class="col-lg-7 pt-2"
                    v-if="
                      !answer ||
                      user.permissions[0].groupReference != '_super_admin'
                    "
                  >
                    <div class="form-group">
                      <textarea
                        class="form-control"
                        v-model="motif"
                        placeholder="Veuillez expliquer ici la raison."
                        cols="50"
                        rows="10"
                      ></textarea>
                    </div>
                  </div>
                  <div
                    class="col-lg-7 pt-2"
                    v-if="
                      user.permissions[0].groupReference == '_super_admin' &&
                      answer
                    "
                  >
                    <div class="form-group">
                      <h5>Proposer un rendez-vous</h5>
                      <textarea
                        class="form-control"
                        v-model="rendezVous"
                        placeholder="Exemple:  - Jeudi 16/06 à 12h00"
                        cols="50"
                        rows="10"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between"
                  v-else-if="
                    user.permissions[0].groupReference == '_super_admin' &&
                    !request.effectiveAmount &&
                    request.status == 'ACCEPTED'
                  "
                >
                  <div class="d-flex flex-row align-items-center col-lg-9">
                    <h6 class="d-inline">Montant donné au salarié</h6>
                    <span class="ml-5 mb-3 color-gray">Montant :</span>
                    <d-input
                      type="text"
                      v-model="effectiveAmount"
                      class="d-inline w-25 ml-3 mb-3"
                    />
                    <span class="d-inline mb-3 ml-1 color-gray">€</span>
                  </div>
                  <div>
                    <button
                      class="btn btn-primary wizard-btn next-btn mr-3"
                      @click="showAdditional"
                    >
                      VALIDER
                    </button>
                  </div>
                </div>
                <div v-else>
                  <h6>{{ $t("days.off.request.already.answered") }}</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="header-data-table">
                  <h5 class="header-data-table__heading">
                    Statut de la demande
                  </h5>
                </div>
                <div class="table-responsive pb-3">
                  <table class="custom-table table t-responsive">
                    <thead class="t-header-color">
                      <tr class="text-center">
                        <th>Suivi</th>
                        <th>Nom</th>
                        <th>Statut</th>
                        <th>Date</th>
                        <th>Commentaires</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(answer, idx) in request.answers" :key="idx">
                        <template
                          v-if="answer.groupReference === GroupsEnum.IN_CHARGE"
                        >
                          <td>N+{{ answer.position }}</td>
                        </template>
                        <template
                          v-if="
                            answer.groupReference === GroupsEnum.SUPER_ADMIN
                          "
                        >
                          <td>Direction</td>
                        </template>
                        <template
                          v-if="answer.groupReference === GroupsEnum.COMPTA"
                        >
                          <td>Comptable</td>
                        </template>
                        <td>{{ answer.name }}</td>
                        <td v-if="answer.status === 'ACCEPTED'">
                          <button class="status-pill-accepted">
                            <span>{{ $t("global.approved") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'PENDING'">
                          <button class="status-pill-pending">
                            <span>{{ $t("global.pending") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'REFUSED'">
                          <button class="status-pill-rejected">
                            <span>{{ $t("global.rejected") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'TREATED'">
                          <button class="status-pill-approved">
                            <span>Contrat traité</span>
                          </button>
                        </td>
                        <td>
                          {{
                            answer.date
                              ? new Date(answer.date).toLocaleDateString(
                                  "fr-FR"
                                ) +
                                " (" +
                                new Date(answer.date).toLocaleTimeString(
                                  "fr-FR"
                                ) +
                                ")"
                              : ""
                          }}
                        </td>
                        <!-- <td>{{ answer.motif ? answer.motif : "" }}</td> -->
                        <td v-if="answer.motif">
                          <button
                            class="HistoryDemands-refuseButton"
                            @click="showReason(answer.motif)"
                          >
                            <i class="fa fa-eye" aria-hidden="true"></i>
                          </button>
                        </td>
                        <td v-else></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <simple-modal ref="reasonModal" :motif="selectedMotif" />
  </div>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import RecapitulatifContractRequest from "../../components/regie/RecapitulatifRegieRequest.vue";
import GroupsEnum from "../../data/groups/GroupsEnum";
import SimpleModal from "../../components/abscenceRequest/SimpleModal.vue";
import loadingSpinner from "../../components/shared/loadingSpinner.vue";

export default {
  name: "regie-answer",
  components: {
    SimpleModal,
    SpinnerDot,
    RecapitulatifContractRequest,
    loadingSpinner,
  },
  mounted() {
    this.reff = this.$route.params.reference;
    this.$services.regieRequestService
      .findByReference(this.$route.params.reference)
      .then(({ data }) => {
        this.request = data;
        this.request.answers.forEach((answer) =>
          this.listOfSupervisor.push(answer.userReference)
        );
        this.originalRequest = JSON.parse(JSON.stringify(data));
        this.alreadyAnswered();
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      isLoading: false,
      request: null,
      answer: true,
      answered: false,
      motif: "",
      GroupsEnum,
      selectedMotif: "",
      originalRequest: null,
      edit: false,
      allStructures: null,
      reff: "",
      rendezVous: null,
      effectiveAmount: null,
      listOfSupervisor: [],
      groupNames: {
        _super_admin: "Direction",
        _admin: "Administrateur",
        _compta: "Comptable",
        _in_charge: "N+1",
        _animateur: "Animateur",
        _receptionist: "Réceptionniste",
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },
  methods: {
    alreadyAnswered() {
      const a = this.request.answers.find(
        (answer) => answer.userReference === this.user.reference
      );
      if (a) {
        if (a.status !== "PENDING") {
          this.answered = true;
        }
      } else {
        this.answered = false;
      }
    },
    confirmRequest() {
      this.loading = true;
      const model = {
        status: this.answer ? "ACCEPTED" : "REFUSED",
        userReference: this.user.reference,
        motif: this.motif,
        rendezVous: this.rendezVous,
      };
      this.$services.regieRequestService
        .confirmRequest(this.request.reference, model)
        .then(({ data }) => {
          this.request = data;
          this.alreadyAnswered();
          this.loading = false;
          this.$router.go(0);
          this.$miniToastr.success("Votre réponse a bien été enregistrée.");
        })
        .catch(() => (this.loading = false));
    },
    showReason(reason) {
      this.selectedMotif = reason;
      this.$refs.reasonModal.openModal();
    },
    markTreated() {
      this.loading = true;
      this.$services.regieRequestService
        .postEffectiveAmount(this.request.reference, {
          validatedByAccountant: true,
          status: "TREATED",
        })
        .then(() => {
          this.loading = false;
          this.$router.go(0);
          this.$miniToastr.success("Votre réponse a bien été enregistrée.");
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    showAdditional() {
      this.loading = true;
      this.$services.regieRequestService
        .postEffectiveAmount(this.request.reference, {
          effectiveAmount: this.effectiveAmount,
        })
        .then(() => {
          this.loading = false;
          this.$router.go(0);
          this.$miniToastr.success("Votre réponse a bien été enregistrée.");
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    backToList() {
      if (this.$route.query.from) {
        this.$router.push(`/`);
      } else {
        this.$router.go(-1);
      }
    },
    async deleteDemand() {
      await this.$services.contractRequestService
        .deleteRequest(this.request.reference)
        .then((res) => {
          this.$router.push(`/gestionnaire/contracts`);
          this.$miniToastr.success("Demande supprimée avec succès");
        })
        .catch((e) => {
          this.$miniToastr.error(
            "Il y a eu une erreur lors de l'supprimée du demande"
          );
        });
    },
    async cancelEditing() {
      this.edit = false;
      this.request = JSON.parse(JSON.stringify(this.originalRequest));
    },
    async editDemand() {
      if (this.edit) {
        this.request.answers[0].status = this.answer ? "ACCEPTED" : "REFUSED";
        this.request.status = this.answer ? "ACCEPTED" : "REFUSED";
        this.request.answers[0].date = new Date();
        if (this.motif) {
          this.request.refuseReason = this.motif;
          this.request.answers[0].motif = this.motif;
        }
        await this.$services.regieRequestService
          .editRequest(this.request.reference, this.request)
          .then((res) => {
            this.$router.go(0);
            this.$miniToastr.success("Demande éditer avec succès");
          })
          .catch((e) => {
            this.$miniToastr.error(
              "Il y a eu une erreur lors de l'éditer du demande"
            );
          });
      }
      this.edit = !this.edit;
      if (this.edit) {
        this.$services.structure.findAll().then((response) => {
          this.allStructures = response.data;
        });
      }
    },
  },
};
</script>

<style scoped>
.HistoryDemands-refuseButton {
  border: 1px #abb6bf solid;
  border-radius: 5px;
  color: #abb6bf;
  padding: 5px 10px;
}

.generate-upload-contract-button {
  background-color: white !important;
  border: 1px solid #4f78e2;
  color: #4f78e2;
}

.uploadFinalDoc {
  /* opacity:0 ; */
  display: none;
}

.contract-answer-fichier {
  text-decoration: underline;
}

.color-gray {
  color: #6c7899;
}

.purple-background {
  background-color: #942192 !important;
}
</style>
